import clsx from 'clsx';
import { CSSProperties } from 'react';

type SkeletonVariant = 'circle' | 'square' | 'rectangle';

interface Props {
  className?: string;
  height?: StandardSizes;
  variant?: SkeletonVariant;
  width?: string | number;
}

export const Skeleton = ({
  className,
  height = 'md',
  variant = 'rectangle',
  width: customWidth,
}: Props) => {
  const classes = useStyles();
  const customStyles: CSSProperties = {
    width: customWidth,
  };

  return (
    <div
      style={customStyles}
      className={clsx(
        className,
        classes.root,
        classes.variant[variant],
        classes.height[height]
      )}
    />
  );
};

const useStyles = () => ({
  root: 'animate-pulse bg-zinc-200 dark:bg-zinc-400/50 w-full',
  variant: {
    circle: 'rounded-full',
    rectangle: 'rounded',
    square: 'rounded',
  },
  height: {
    sm: 'h-2',
    md: 'h-4',
    lg: 'h-6',
  },
});
